import styled from '@emotion/styled'

import { Button, palette, spacing, Text, typography } from 'main/ui'

export const SubmitButton = styled(Button)`
  margin-bottom: ${spacing.minorScale(5)}px;
`

export const GroupWrapper = styled.div`
  margin-bottom: ${spacing.minorScale(5)}px;
`

export const ErrorMessage = styled(Text)`
  color: ${palette.poppy2};
`
export const GrayText = styled(Text)`
  font-size: ${typography.fontSize.text};
  color: ${palette.slate};
`

export const BlueSpan = styled.span`
  font-size: ${typography.fontSize.text};
  color: ${palette.skyBlue2};
  cursor: pointer;
`
